<template lang="pug">
div.i-pay-card
  form(class="i-interseguro__content__form")
    div(class="i-interseguro__content__form__content")
      div.i-input__box
        p N&uacute;mero de tarjeta
        div(id="inputTarjeta" style="")
        div(class="i-input--error" v-if="errorTarget") {{ errorTargetText }}
      div.i-input__box__double
        div.i-input__box
          p Fecha de exp.
          div(id="inputFechaNacimiento" style="")
          div(class="i-input--error" v-if="errorExpiry") {{ errorExpiryText }}
        div.i-input__box
          p.m-question CVV&nbsp;
          div(id="inputCvv" style="")
          div(class="i-input--error" v-if="errorCvv") {{ errorCvvText }}
      div(class="i-input__box i-input__box--affiliation" v-if="showCheckRecurrent")
        div(class="i-input i-input--checkbox")
          input(id="check_affiliation" type="checkbox" v-model="checkValuePp" @change="changeCheck()" name="check_affiliation")
          label(for="check_affiliation")
            i &#10003;
          p(style="font-size: 13px; margin-top: -6px !important; text-align: justify;") {{affiliationText}}
      p Al continuar acepto los &nbsp;
        span(id="open_terms" @click="openTerms()") T&eacute;rminos y condiciones
      button(class="i-button" @click="pay" id="submit-pay-card" type="button") {{ `${buttonText}${(showCheckRecurrent && checkValuePp)?' y afiliarme':''}` }}
        div(class="i-dues__footer__price") {{ buttonCurrency }}
          span {{ buttonAmount }}
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from 'vuex'
export default {
  name: 'Niubiz',
  props: {
    configuration: {
      type: Object,
      required: true
    },
    elementStyle: {
      type: Object,
      required: true
    },
    dataClient: {
      type: Object,
      required: true
    },
    showCheckRecurrent: Boolean,
    showTermsConditions: Boolean,
    affiliationText: String,
    buttonText: String,
    buttonCurrency: String,
    buttonAmount: String,
    showCheckOptionTrue: Boolean
  },
  data () {
    return {
      cardNumber: '',
      cardExpiry: '',
      cardCvv: '',
      checkValuePp: this.showCheckOptionTrue || false,
      errorTarget: false,
      errorExpiry: false,
      errorCvv: false,
      errorTargetText: '',
      errorExpiryText: '',
      errorCvvText: '',
      checkConditions: false,
      showErrorCheck: true
    }
  },
  mounted () {
    let self = this
    window.onload = self.loadForm()
    try {
      // #004.45: Checkout - Tarjeta PENDIENTE
      let cantidad = 0
      let price = parseFloat((this.paymentsInfo || {}).paymentTotal).toFixed(2)

      for (let cuota of this.paymentsInfo.polizaSeleccionada.cuotas) {
        if (cuota.selected) {
          cantidad++
        }
      }

      this.$gtm.trackEvent({
        'event': 'checkout',
        'dimension10': cantidad,
        'ecommerce': {
          'checkout': {
            'actionField': {'step': '1'},
            'products': [{
              'id': this.paymentsInfo.polizaSeleccionada.policyNumber,
              'name': this.paymentsInfo.polizaSeleccionada.name,
              'price': parseFloat(price),
              'brand': 'Interseguro',
              'category': 'Zona Segura',
              'variant': 'Póliza',
              'quantity': 1
            }]
          }
        }
      })

      this.$gtm.trackEvent({
        'event': 'begin_checkout',
        'NroCuotas': cantidad,
        'Paso': 1,
        'ecommerce': {
          'items': [{
            'item_id': this.paymentsInfo.polizaSeleccionada.policyNumber,
            'item_name': this.paymentsInfo.polizaSeleccionada.name,
            'price': parseFloat(price),
            'item_brand': 'Interseguro',
            'item_category': 'Zona Segura',
            'item_variant': 'Póliza',
            'quantity': 1
          }]
        }
      })
    } catch (err) {}
  },
  methods: {
    async loadForm () {
      let self = this
      try {
        this.elementStyle.base.fontWeight = '400'
        this.elementStyle.base.fontFamily = '\'Omnes Regular\', sans-serif'
        this.elementStyle.base.fontSize = '16px'
        this.elementStyle.base.fontSmoothing = 'antialiased'
        // console.log('configuration session key: ', this.configuration.sessionkey)
        window.configuration = this.configuration
        payform.setConfiguration(this.configuration)
        this.cardNumber = payform.createElement(
          'card-number', { style: this.elementStyle, placeholder: '0000 0000 0000 0000' },
          'inputTarjeta'
        )
        this.cardNumber.catch((error) => {
          console.log('error promise cardnumber1:', error)
        })
        this.cardNumber.then(element => {
          // console.log('error al cargar numero de tarjeta', element)
          element.on('dcc', function (data) {
            // console.log('change data DCC', data)
          })
          element.on('installments', function (data) {
            // console.log('change data installments', data)
          })
          element.on('change', function (data) {
            // console.log('change data changeCard', data)
            if (data.length > 0) {
              self.errorTarget = true
              self.errorTargetText = 'Su número de tarjeta no es válido.'
            } else {
              self.errorTarget = false
            }
          })
        }, () => {
          // console.log('error al cargar numero de tarjeta', err)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        }).catch(/* err */() => {
          // console.log('error al cargar cardnumber', err)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        })

        this.cardExpiry = payform.createElement(
          'card-expiry', {
            style: this.elementStyle,
            placeholder: 'mm/aa'
          }, 'inputFechaNacimiento'
        )
        this.cardExpiry.catch((error) => {
          console.log('error promise exp 1:', error)
        })
        this.cardExpiry.then(element => {
          element.on('change', function (data) {
            // console.log('change data changeExpiry', data)
            if (data.length > 0) {
              self.errorExpiry = true
              // this.errorExpiryText = data[0].es.message
              self.errorExpiryText = 'Verifica la fecha'
            } else {
              self.errorExpiry = false
            }
          })
        }, () => {
          // console.log('error al cargar fecha de expiración', err)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        }).catch(err => {
          console.log('error al cargar fecha de exp.', err)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        })

        this.cardCvv = payform.createElement(
          'card-cvc', {
            style: this.elementStyle,
            placeholder: 'CVV'
          },
          'inputCvv'
        )
        this.cardCvv.catch((error) => {
          console.log('error promise cvv1:', error)
        })
        this.cardCvv.then(element => {
          element.on('change', function (data) {
            // console.log('change data changeCvv', data)
            if (data.length > 0) {
              self.errorCvv = true
              // this.errorCvvText = data[0].es.message
              self.errorCvvText = 'Verifica el CVV'
            } else {
              self.errorCvv = false
            }
          })
        }, err => {
          console.log('error al cargar cvv', err)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        }).catch(err => {
          console.log('error al cargar cvv', err)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        })
      } catch (e) {
        console.log('Error: ', e)
        self.$emit('hideloader')
        // self.$root.$emit('hideloader')
      }
    },
    openTerms () {
      this.$emit('open-conditions')
      // this.$root.$emit('open-conditions')
    },
    changeCheck () {
      let self = this
      self.$emit('check-change-recurrent', { checked: self.checkValuePp })
      // self.$root.$emit('check-change-recurrent', { checked: self.checkValuePp })
    },
    pay () {
      let self = this
      self.$emit('showloader')
      // self.$root.$emit('showloader')
      self.$emit('check-change-recurrent', { checked: this.checkValuePp })
      // self.$root.$emit('check-change-recurrent', { checked: this.checkValuePp })
      self.$emit('submit-niubiz', { checked: this.checkValuePp })
      // self.$root.$emit('submit-niubiz', { checked: this.checkValuePp })

      payform.createToken([this.cardNumber, this.cardExpiry, this.cardCvv], this.dataClient)
        .catch(function (error) {
          self.$emit('carderror', error)
          // self.$root.$emit('carderror', error)
          self.$emit('hideloader')
          // self.$root.$emit('hideloader')
        })
    }
  },
  computed: {
    ...mapGetters('payments', ['paymentsInfo'])
  }
}
</script>

<style scoped>
 html {
    line-height: 1.15;
    /* 1 */
    -webkit-text-size-adjust: 100%;
    /* 2 */
  }
  /**
   * Remove the margin in all browsers.
   */
  body {
    margin: 0;
    background-color: #000;
  }
  /**
   * Render the `main` element consistently in IE.
   */
  main {
    display: block;
  }

  /**
   * Correct the font size and margin on `h1` elements within `section` and
   * `article` contexts in Chrome, Firefox, and Safari.
   */
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  /* Grouping content
     ========================================================================== */
  /**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */
  hr {
    box-sizing: content-box;
    /* 1 */
    height: 0;
    /* 1 */
    overflow: visible;
    /* 2 */
  }
  /* Text-level semantics
     ========================================================================== */
  /**
   * Remove the gray background on active links in IE 10.
   */
  a {
    background-color: transparent;
  }
  /**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */
  abbr[title] {
    border-bottom: none;
    /* 1 */
    text-decoration: underline;
    /* 2 */
    text-decoration: underline dotted;
    /* 2 */
  }
  /**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */
  b,
  strong {
    font-weight: bolder;
  }
  /**
   * Add the correct font size in all browsers.
   */
  small {
    font-size: 80%;
  }
  /**
   * Prevent `sub` and `sup` elements from affecting the line height in
   * all browsers.
   */
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  /* Embedded content
     ========================================================================== */
  /**
   * Remove the border on images inside links in IE 10.
   */
  img {
    border-style: none;
  }
  /* Forms
     ========================================================================== */
  /**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    /* 1 */
    font-size: 100%;
    /* 1 */
    line-height: 1.15;
    /* 1 */
    margin: 0;
    /* 2 */
  }
  /**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */
  button,
  input {
    /* 1 */
    overflow: visible;
  }
  /**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */
  button,
  select {
    /* 1 */
    text-transform: none;
  }
  /**
   * Correct the inability to style clickable types in iOS and Safari.
   */
  button,
  [type=button],
  [type=reset],
  [type=submit] {
    -webkit-appearance: button;
  }
  /**
   * Remove the inner border and padding in Firefox.
   */
  button::-moz-focus-inner,
  [type=button]::-moz-focus-inner,
  [type=reset]::-moz-focus-inner,
  [type=submit]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  /**
   * Restore the focus styles unset by the previous rule.
   */
  button:-moz-focusring,
  [type=button]:-moz-focusring,
  [type=reset]:-moz-focusring,
  [type=submit]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  /**
   * Correct the padding in Firefox.
   */
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  /**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from `fieldset` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    `fieldset` elements in all browsers.
   */
  legend {
    box-sizing: border-box;
    /* 1 */
    color: inherit;
    /* 2 */
    display: table;
    /* 1 */
    max-width: 100%;
    /* 1 */
    padding: 0;
    /* 3 */
    white-space: normal;
    /* 1 */
  }
  /**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */
  progress {
    vertical-align: baseline;
  }
  /**
   * Remove the default vertical scrollbar in IE 10+.
   */
  textarea {
    overflow: auto;
  }
  /**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */
  [type=checkbox],
  [type=radio] {
    box-sizing: border-box;
    /* 1 */
    padding: 0;
    /* 2 */
  }
  /**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */
  [type=number]::-webkit-inner-spin-button,
  [type=number]::-webkit-outer-spin-button {
    height: auto;
  }
  /**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */
  [type=search] {
    -webkit-appearance: textfield;
    /* 1 */
    outline-offset: -2px;
    /* 2 */
  }
  /**
   * Remove the inner padding in Chrome and Safari on macOS.
   */
  [type=search]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  /**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to `inherit` in Safari.
   */
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    /* 1 */
    font: inherit;
    /* 2 */
  }
  /* Interactive
     ========================================================================== */
  /*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */
  details {
    display: block;
  }
  /*
   * Add the correct display in all browsers.
   */
  summary {
    display: list-item;
  }
  /* Misc
     ========================================================================== */
  /**
   * Add the correct display in IE 10+.
   */
  template {
    display: none;
  }
  /**
   * Add the correct display in IE 10.
   */
  [hidden] {
    display: none;
  }
  /*layout*/
  /*breakpoints*/
  body {
    margin: 0;
    padding: 0;
    color: #0855c4;
    /*min-width: 300px;*/
    text-align: center;
    position: relative;
    font-size: 12px;
    font-weight: 300;
    line-height: 1.35;
    font-family: inherit;
    -webkit-text-size-adjust: 100%;
    letter-spacing: 0.005em;
    background-color: #f1f4f9;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  @media only screen and (min-width: 1024px) {
    body {
      font-size: 14px;
    }
  }
  body * {
    user-select: none;
    box-sizing: border-box;
  }

  a {
    color: #0855c4;
    text-decoration: none;
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
  a:hover {
    color: #0855c4;
  }
  small {
    font-size: 70%;
  }
  b,
  strong {
    font-family: "Omnes-Semibold";
  }
  em {
    font-style: italic;
  }
  img {
    height: auto;
    max-width: 100%;
    vertical-align: middle;
  }
  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-bottom: 20px;
  }
  h1,
  .i-h1 {
    font-size: 16px;
  }
  @media only screen and (min-width: 768px) {
    h1,
  .i-h1 {
      font-size: 30px;
    }
  }
  h2,
  .i-h2 {
    font-size: 16px;
  }
  @media only screen and (min-width: 768px) {
    h2,
  .i-h2 {
      font-size: 30px;
    }
  }
  h3,
  .i-h3 {
    font-size: 14px;
  }
  @media only screen and (min-width: 768px) {
    h3,
  .i-h3 {
      font-size: 16px;
    }
  }
  h4,
  .i-h4 {
    font-size: 14px;
  }
  @media only screen and (min-width: 1024px) {
    h4,
  .i-h4 {
      font-size: 16px;
    }
  }
  h5,
  .i-h5 {
    font-size: 14px;
  }
  @media only screen and (min-width: 1024px) {
    h5,
  .i-h5 {
      font-size: 20px;
    }
  }
  h6,
  .i-h6 {
    font-size: 14px;
  }
  @media only screen and (min-width: 1024px) {
    h6,
  .i-h6 {
      font-size: 20px;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    line-height: 1.13;
    margin-bottom: 20px;
    color: #233b5e;
    font-weight: initial;
    font-family: "Omnes-Semibold";
    transition: color 0.3s;
  }
  @media only screen and (min-width: 425px) {
    h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
      margin-bottom: 30px;
    }
  }
  h1.i--normal,
  h2.i--normal,
  h3.i--normal,
  h4.i--normal,
  h5.i--normal,
  h6.i--normal {
    font-weight: normal;
  }
  h1.i--normal strong,
  h2.i--normal strong,
  h3.i--normal strong,
  h4.i--normal strong,
  h5.i--normal strong,
  h6.i--normal strong {
    font-weight: 700;
  }
  .i-container {
    width: auto;
    margin: auto;
    padding-left: 21px;
    padding-right: 21px;
  }
  @media only screen and (min-width: 425px) {
    .i-container {
      padding-left: 30px;
      padding-right: 30px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-container {
      padding-left: 0;
      padding-right: 0;
      width: 90%;
    }
  }
  @media only screen and (min-width: 1024px) {
    .i-container {
      width: 750px;
    }
  }
  .i-interseguro {
    background-color: #f1f4f9;
  }
  .i-interseguro:before {
    content: "";
    background-color: rgba(8, 85, 196, 0.4);
  }
  .i-interseguro__content {
    display: flex;
    flex-direction: column;
    padding: 40px 0;
  }
  @media only screen and (min-width: 768px) {
    .i-interseguro__content {
      flex-direction: row;
      justify-content: space-between;
      padding: 60px 0;
    }
  }
  .i-interseguro__content__heading {
    display: flex;
    margin-bottom: 20px;
    align-items: center;
  }
  @media only screen and (min-width: 460px) {
    .i-interseguro__content__heading {
      margin: 0 auto 20px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-interseguro__content__heading {
      width: 347px;
      display: block;
      text-align: left;
      margin: initial;
    }
  }
  .i-interseguro__content__heading img {
    height: 60px;
  }
  @media only screen and (min-width: 768px) {
    .i-interseguro__content__heading img {
      height: 70px;
    }
  }
  .i-interseguro__content__heading h2 {
    width: 170px;
    color: #fff;
    font-weight: 100;
    text-align: left;
    margin: 0 0 0 20px;
    font-family: "Omnes-Regular";
  }
  @media only screen and (min-width: 360px) {
    .i-interseguro__content__heading h2 {
      width: 255px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-interseguro__content__heading h2 {
      width: auto;
      margin: 33px 0 0;
      line-height: 46px;
    }
  }
  .i-interseguro__content__form {
    width: 100%;
    text-align: left;
    color: #233b5e;
    padding: 28px 21px;
    border-radius: 10px;
    background-color: #fff;
  }
  @media only screen and (min-width: 360px) {
    .i-interseguro__content__form {
      max-width: 400px;
      margin: 0 auto;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-interseguro__content__form {
      margin: initial;
    }
  }
  .i-interseguro__content__form button i {
    top: 20px;
    right: 20px;
    text-align: right;
    position: absolute;
  }
  .i-interseguro__content__form h3 {
    margin-bottom: 28px;
  }
  .i-background__left {
    background-color: #f1f4f9;
  }
  .i-background__right {
    background-color: #fff;
  }
  .i-background__container {
    padding: 0 20px;
  }
  @media only screen and (min-width: 425px) {
    .i-background__container {
      padding-left: 30px;
      padding-right: 30px;
    }
  }
  @media only screen and (min-width: 640px) {
    .i-background__container {
      padding: 0;
    }
  }
  @media only screen and (min-width: 640px) {
    .i-background {
      width: auto;
      display: flex;
    }
    .i-background__left, .i-background__right {
      width: 50%;
      min-height: 100vh;
      padding: 0 20px;
      display: flex;
      justify-content: flex-end;
    }
    .i-background__left {
      background-position: 0 center;
      background-size: initial;
    }
    .i-background__right {
      justify-content: flex-start;
    }
    .i-background__container {
      max-width: 355px;
      width: 100%;
      margin-top: 64px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-background-image {
      background-size: contain;
      background-position: bottom;
      background-repeat: no-repeat;
    }
  }
  .i-background-color {
    min-height: 100vh;
    background-color: #f1f4f9;
  }
  .i-header {
    background-color: #0855c4;
    text-align: left;
    padding: 20px 0 0;
  }
  .i-header--white {
    background-color: #fff;
  }
  .i-header--white .i-header__left picture img {
    width: auto;
  }
  .i-header .i-container {
    display: flex;
    justify-content: space-between;
  }
  @media only screen and (min-width: 768px) {
    .i-header {
      padding: 40px 0 0;
    }
  }
  @media only screen and (min-width: 1024px) {
    .i-header .i-container {
      width: 90%;
    }
  }
  @media only screen and (min-width: 1280px) {
    .i-header .i-container {
      width: 1200px;
    }
  }
  .i-header__left {
    display: flex;
    align-items: center;
  }
  .i-header .i-return {
    font-size: 15px;
    padding: 10px 17px 10px 0;
    display: none;
  }
  .i-header .m-icon-svg {
    display: flex;
  }
  .i-header img {
    height: 20px;
    width: 121px;
  }
  @media only screen and (min-width: 768px) {
    .i-header img {
      height: 24px;
      width: 145px;
    }
  }
  .i-header p {
    margin: 0;
    color: #0855c4;
    display: none;
    vertical-align: middle;
    font-family: "Omnes-Regular";
  }
  @media only screen and (min-width: 768px) {
    .i-header p {
      font-size: 16px;
    }
  }
  .i-header p::before {
    width: 5px;
    content: "";
    height: 5px;
    margin: 0 7px;
    border-radius: 50%;
    display: inline-block;
    background-color: #0caced;
    vertical-align: middle;
  }
  .i-header__right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .i-header__right span.i-name {
    color: #0caced;
    margin-right: 10px;
  }
  .i-header__right .i-button-close {
    background-color: #0caced;
    color: #fff;
  }
  @media only screen and (min-width: 640px) {
    .i-header__right {
      display: flex;
    }
  }
  .i-header--white {
    background-color: #fff;
    height: 50px;
    padding: 0;
    line-height: 50px;
  }
  @media only screen and (min-width: 640px) {
    .i-header--absolute {
      background-color: transparent;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .i-header--absolute p {
      display: inline-block;
    }
    .i-header--absolute .i-button-close {
      color: #fff;
    }
  }
  .i-button,
  .i-button button,
  .i-button input[type=button],
  .i-button input[type=submit] {
    font-style: normal;
    font-weight: 500;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    margin: 0 auto;
    display: inline-block;
    vertical-align: top;
    min-width: 178px;
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    padding: 0 20px;
    text-align: left;
    background-color: var(--fuchsia-color);
    user-select: none;
    text-transform: uppercase;
    transform: translateY(0);
    transition: transform 200ms ease-in-out, background-color 300ms ease-in-out, border-color 300ms ease-in-out, box-shadow 300ms ease-in-out;
    overflow: hidden;
    box-shadow: none;
    border: 0;
  }
  @media only screen and (min-width: 768px) {
    .i-button,
  .i-button button,
  .i-button input[type=button],
  .i-button input[type=submit] {
      min-width: 225px;
      line-height: 52px;
      font-size: 16px;
    }
  }
  @media only screen and (min-width: 1280px) {
    .i-button,
  .i-button button,
  .i-button input[type=button],
  .i-button input[type=submit] {
      padding: 0 10px;
    }
  }
  .i-button:hover,
  .i-button button:hover,
  .i-button input[type=button]:hover,
  .i-button input[type=submit]:hover {
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  }
  .i-button:hover::before,
  .i-button button:hover::before,
  .i-button input[type=button]:hover::before,
  .i-button input[type=submit]:hover::before {
    opacity: 0;
    animation: hoverAnimation;
    animation-duration: 1.5s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    animation-direction: alternate;
  }
  .i-button:active,
  .i-button button:active,
  .i-button input[type=button]:active,
  .i-button input[type=submit]:active {
    transform: translateY(1px);
  }
  .i-button:active::before,
  .i-button button:active::before,
  .i-button input[type=button]:active::before,
  .i-button input[type=submit]:active::before {
    opacity: 1;
  }
  .i-button::before,
  .i-button button::before,
  .i-button input[type=button]::before,
  .i-button input[type=submit]::before {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    content: "";
    opacity: 1;
    border-radius: 8px;
    transition: opacity 300ms ease-in-out;
  }
  @media only screen and (min-width: 768px) {
    .i-button::before,
  .i-button button::before,
  .i-button input[type=button]::before,
  .i-button input[type=submit]::before {
      border-radius: 10px;
    }
  }
  .i-button picture,
  .i-button button picture,
  .i-button input[type=button] picture,
  .i-button input[type=submit] picture {
    margin-right: 10px;
  }
  .i-button span,
  .i-button button span,
  .i-button input[type=button] span,
  .i-button input[type=submit] span {
    position: relative;
    z-index: 1;
  }
  .i-button--disabled {
    pointer-events: none;
    background-color: #8ea1bd;
  }
  .i-button-close {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #e2e8f1;
    display: flex !important;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    color: #fff;
  }
  .i-button-close:hover {
    transform: rotate(90deg);
  }
  .i-input__box {
    margin-bottom: 15px;
  }
  .i-input__box p {
    margin: 0 0 10px;
  }
  button,
  button:focus,
  button:visited,
  button:active,
  button:hover,
  input[type=button],
  input[type=submit] {
    transition-property: all;
    transition-duration: 0.1s;
    transition-timing-function: ease-in-out;
  }
  input,
  select {
    height: 50px;
    line-height: normal;
  }
  input,
  optgroup,
  select,
  option,
  textarea {
    background-color: #fff;
    border: 1px solid #e2e8f1;
    color: #233b5e;
    font: 400 14px "Omnes-Regular";
    margin-bottom: 0;
    padding: 0 16px;
    width: 100%;
    display: block;
    transition-property: all;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    border-radius: 5px;
    box-shadow: none;
  }
  @media only screen and (min-width: 425px) {
    input,
  optgroup,
  select,
  option,
  textarea {
      font-size: 14px;
    }
  }
  @media only screen and (min-width: 640px) {
    input,
  optgroup,
  select,
  option,
  textarea {
      font-size: 16px;
    }
  }
  input:focus,
  optgroup:focus,
  select:focus,
  option:focus,
  textarea:focus {
    outline: none;
  }
  input:not([type=buttom]):not([type=submit]):focus,
  textarea:focus {
    border-color: #0855c4;
    background-color: #fff;
    outline: 0 none;
  }
  textarea {
    height: 150px;
    margin: 0;
    padding: 12px;
    font-family: "Omnes-Regular";
    line-height: 1.3;
  }
  input::-webkit-input-placeholder,
  select::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #233b5e;
  }
  input:-moz-placeholder,
  select:-moz-placeholder,
  textarea:-moz-placeholder {
    /* Firefox 18- */
    color: #233b5e;
  }
  input::-moz-placeholder,
  select::-moz-placeholder,
  textarea::-moz-placeholder {
    /* Firefox 19+ */
    color: #233b5e;
  }
  input:-ms-input-placeholder,
  select:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #233b5e;
  }
  input[type=checkbox],
  input[type=radio] {
    width: auto;
  }
  /*validacion*/
  form label.error {
    font-size: 12px;
    letter-spacing: 0.005em;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-name: fadeInDown;
  }
  @keyframes fadeInDown {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  form label.error:not(#captcha-error):not(#captcha_2-error) {
    position: absolute;
    right: 0;
    top: 0;
    background-color: transparent;
    color: #0855c4;
    padding: 3px 10px;
    z-index: 1;
  }
  .i-input {
    position: relative;
    margin-bottom: 15px;
    z-index: 1;
  }
  .i-input__error {
    color: #0855c4;
    height: 50px;
    line-height: 1.2;
    border-radius: 5px;
    padding: 12px 10px;
    position: relative;
    margin-bottom: 20px;
    background-color: #deeafd;
  }
  @media only screen and (min-width: 768px) {
    .i-input__error {
      height: 55px;
    }
  }
  .i-input__error p {
    margin: 0;
    font-size: 12px;
  }
  .i-input__error p span {
    display: block;
  }
  @media only screen and (min-width: 768px) {
    .i-input__error p {
      font-size: 13px;
    }
  }
  .i-input__error .i-button-close {
    top: 15px;
    right: 10px;
    position: absolute;
    background-color: #0855c4;
  }
  .i-input label {
    font-size: 14px;
    font-weight: 500;
    color: #e2e8f1;
    padding: 5px 12px 0;
    vertical-align: top;
    display: inline-block;
  }
  @media only screen and (min-width: 425px) {
    .i-input label {
      font-size: 16px;
    }
  }
  .i-input--small label {
    font-size: 12px;
  }
  .i-input--medium {
    margin-bottom: 10px;
  }
  .i-input--medium input,
  .i-input--medium select {
    height: 36px;
    line-height: 36px;
  }
  .i-input--large {
    margin-bottom: 20px;
  }
  @media only screen and (min-width: 640px) {
    .i-input--large {
      margin-bottom: 30px;
    }
  }
  .i-input--select {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
  }
  .i-input--select:after {
    content: "";
    position: absolute;
    background-color: red;
    height: 20px;
    width: 20px;
    right: 12px;
    top: 0;
    z-index: 99999;
    background-size: 16px auto;
  }
  .i-input--checkbox {
    margin-bottom: 0;
  }
  .i-input--checkbox input {
    opacity: 0;
    appearance: none;
  }
  .i-input--checkbox input:checked ~ label {
    border: none;
    background-color: #0855c4;
  }
  .i-input--checkbox input:checked ~ label i {
    opacity: 1;
  }
  .i-input--checkbox label {
    padding: 0;
    width: 20px;
    height: 20px;
    font-size: 12px;
    cursor: pointer;
    transition: 0.4s;
    border-radius: 50%;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    border: 1px solid #e2e8f1;
  }
  .i-input--checkbox label i {
    opacity: 0;
    color: #0855c4;
  }
  .i-input-select-container {
    position: relative;
  }
  .i-input-select-container i {
    position: absolute;
    right: 20px;
    font-size: 16px;
    line-height: 50px;
  }
  .i-modal {
    left: 0;
    opacity: 0;
    width: 95%;
    z-index: -1;
    height: 95%;
    position: fixed;
    text-align: left;
    overflow: hidden;
    color: #233b5e;
    margin-left: auto;
    overflow-y: scroll;
    padding: 50px 20px;
    margin-right: auto;
    transition: all 300ms;
    border-radius: 10px;
    background-color: #f1f4f9;
    transform: translate(8px, 15px);
  }
  @media only screen and (min-width: 768px) {
    .i-modal {
      top: -40%;
      left: 50%;
      height: auto;
      max-width: 750px;
      overflow: hidden;
      border-radius: 5px;
      transform: translate(-50%, -50%);
    }
  }
  .i-modal--active {
    opacity: 1;
    z-index: 999;
    display: block;
  }
  @media only screen and (min-width: 768px) {
    .i-modal--active {
      top: 50%;
    }
  }
  .i-modal__close {
    top: 20px;
    right: 20px;
    text-align: right;
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 50%;
    background-color: #233b5e;
  }
  .i-modal__close:hover {
    transform: rotate(90deg);
    background-color: rgba(35, 59, 94, 0.8);
  }
  .i-modal__close span.fas.fa-times {
    color: #fff;
    line-height: 20px;
  }
  .i-modal h3 {
    color: #0855c4;
    text-align: center;
  }
  @media only screen and (min-width: 768px) {
    .i-modal h3 {
      text-align: left;
    }
  }
  .i-modal p {
    text-align: justify;
  }
  .i-modal-overlay {
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    position: fixed;
    overflow: hidden;
    transition: all 300ms;
    background-color: #000;
  }
  .i-modal-overlay--active {
    z-index: 99;
    opacity: 0.5;
    display: block;
  }
  @keyframes bounceInUp {
    0% {
      opacity: 0;
      overflow: hidden;
      transform: translateY(2000px);
    }
    60% {
      opacity: 1;
      transform: translateY(-30px);
    }
    80% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0);
    }
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]),
  select {
    height: 45px;
    line-height: 45px;
  }
  @media only screen and (min-width: 768px) {
    input:not([type=radio]):not([type=checkbox]):not([type=file]),
  select {
      height: 50px;
      line-height: 50px;
    }
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]),
  optgroup,
  select,
  textarea {
    background-color: #fff;
    border: 1px solid #8ea1bd;
    color: #233b5e;
    font-weight: 400;
    margin-bottom: 20px;
    width: 100%;
    display: block;
    padding: 0 12px 0 20px;
    font-family: "Omnes-Regular";
    font-size: 14px;
    transition-property: border-color, background-color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    border-radius: 4px;
  }
  @media only screen and (min-width: 768px) {
    input:not([type=radio]):not([type=checkbox]):not([type=file]),
  optgroup,
  select,
  textarea {
      border-radius: 8px;
      font-weight: 500;
    }
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span,
  optgroup ~ span,
  select ~ span,
  textarea ~ span {
    top: 50%;
    left: 50%;
    opacity: 1;
    width: 100%;
    color: #8ea1bd;
    font-weight: 400;
    position: absolute;
    text-align: center;
    pointer-events: none;
    font-size: 14px;
    transition: all 0.3s ease;
    transform: translate(-50%, -50%);
  }
  @media (min-width: 768px) {
    input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span,
  optgroup ~ span,
  select ~ span,
  textarea ~ span {
      font-size: 16px;
    }
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--focus, input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--active,
  optgroup ~ span.js--focus,
  optgroup ~ span.js--active,
  select ~ span.js--focus,
  select ~ span.js--active,
  textarea ~ span.js--focus,
  textarea ~ span.js--active {
    top: 1px;
    left: 50%;
    padding: 0 4px;
    font-size: 11px;
    font-weight: 400;
    color: #233b5e;
    background: transparent;
    transform: translate(-50%, 0);
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]).error,
  optgroup.error,
  select.error,
  textarea.error {
    border-color: orange !important;
    box-shadow: 0 0 0 1px orange;
    background-repeat: no-repeat;
    background-position: calc(100% - 12px) center;
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]).error:focus,
  optgroup.error:focus,
  select.error:focus,
  textarea.error:focus {
    box-shadow: 0 0 0 1px orange;
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file]).error ~ span, input:not([type=radio]):not([type=checkbox]):not([type=file]).error ~ p,
  optgroup.error ~ span,
  optgroup.error ~ p,
  select.error ~ span,
  select.error ~ p,
  textarea.error ~ span,
  textarea.error ~ p {
    color: orange !important;
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file])[type=date],
  optgroup[type=date],
  select[type=date],
  textarea[type=date] {
    color: #fff;
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file])[type=date].datefix,
  optgroup[type=date].datefix,
  select[type=date].datefix,
  textarea[type=date].datefix {
    color: #233b5e;
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file])[type=text]:disabled,
  optgroup[type=text]:disabled,
  select[type=text]:disabled,
  textarea[type=text]:disabled {
    background-color: #e2e8f1;
    border-color: #e2e8f1;
  }
  input:not([type=radio]):not([type=checkbox]):not([type=file])[type=text]:disabled ~ span,
  optgroup[type=text]:disabled ~ span,
  select[type=text]:disabled ~ span,
  textarea[type=text]:disabled ~ span {
    color: #dddddd;
  }
  input:not([type=button]):not([type=submit]):focus,
  textarea:focus {
    border-color: #f1f4f9;
    background-color: #fff;
    outline: 0 none;
  }
  textarea {
    height: 125px;
    padding-top: 15px;
  }
  .i-input {
    width: 100%;
    position: relative;
    margin-bottom: 15px;
  }
  .i-input--error {
    color: #dc3545;
    font-size: 10px;
    opacity: 1;
  }
  @media only screen and (min-width: 768px) {
    .i-input--error {
      font-size: 12px;
      text-align: left;
    }
  }
  .i-input.i-input--has-description--js {
    margin-bottom: 34px;
  }
  .i-input p {
    position: absolute;
    left: 20px;
    top: 0;
    margin-top: 3px;
    font-size: 11px;
    font-weight: 400;
    color: #8ea1bd;
    margin-bottom: 0;
  }
  @media only screen and (min-width: 1024px) {
    .i-input p {
      margin-top: 5px;
    }
  }
  .i-input label.error {
    overflow: hidden;
    padding: 0;
    position: absolute;
    height: 20px;
    width: 20px;
    right: 10px;
    top: 50%;
    margin-top: -10px;
    color: transparent;
    background-repeat: no-repeat;
    background-size: 20px auto;
    opacity: 0;
    animation-name: error_active;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
  }
  @keyframes error_active {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .i-input:hover input:not([type=radio]):not([type=checkbox]):not([type=file]):not(:disabled),
  .i-input:hover optgroup:not(:disabled),
  .i-input:hover select:not(:disabled),
  .i-input:hover textarea:not(:disabled) {
    border-color: #f1f4f9;
  }
  .i-input:hover input:not([type=radio]):not([type=checkbox]):not([type=file]):not(:disabled) ~ span:not(.js--focus):not(.js--active),
  .i-input:hover optgroup:not(:disabled) ~ span:not(.js--focus):not(.js--active),
  .i-input:hover select:not(:disabled) ~ span:not(.js--focus):not(.js--active),
  .i-input:hover textarea:not(:disabled) ~ span:not(.js--focus):not(.js--active) {
    color: #233b5e;
  }
  .i-input--solid input:not([type=radio]):not([type=checkbox]):not([type=file]),
  .i-input--solid optgroup,
  .i-input--solid select,
  .i-input--solid textarea {
    padding-top: 14px;
    border-color: #e2e8f1;
    background-color: #e2e8f1;
  }
  .i-input--solid input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--focus, .i-input--solid input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--active,
  .i-input--solid optgroup ~ span.js--focus,
  .i-input--solid optgroup ~ span.js--active,
  .i-input--solid select ~ span.js--focus,
  .i-input--solid select ~ span.js--active,
  .i-input--solid textarea ~ span.js--focus,
  .i-input--solid textarea ~ span.js--active {
    top: 4px;
    background-color: transparent;
  }
  @media only screen and (min-width: 768px) {
    .i-input--solid input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--focus, .i-input--solid input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--active,
  .i-input--solid optgroup ~ span.js--focus,
  .i-input--solid optgroup ~ span.js--active,
  .i-input--solid select ~ span.js--focus,
  .i-input--solid select ~ span.js--active,
  .i-input--solid textarea ~ span.js--focus,
  .i-input--solid textarea ~ span.js--active {
      top: 7px;
    }
  }
  .i-input--solid input:not([type=button]):not([type=submit]):focus,
  .i-input--solid textarea:focus {
    background-color: #e2e8f1;
  }
  .i-input--solid--white input:not([type=radio]):not([type=checkbox]):not([type=file]),
  .i-input--solid--white optgroup,
  .i-input--solid--white select,
  .i-input--solid--white textarea {
    border-color: #fff;
    background-color: #fff;
  }
  .i-input--solid--white input:not([type=radio]):not([type=checkbox]):not([type=file]):focus,
  .i-input--solid--white optgroup:focus,
  .i-input--solid--white select:focus,
  .i-input--solid--white textarea:focus {
    background-color: #fff;
  }
  .i-input--solid--white:hover input:not([type=radio]):not([type=checkbox]):not([type=file]):not(:disabled),
  .i-input--solid--white:hover optgroup:not(:disabled),
  .i-input--solid--white:hover select:not(:disabled),
  .i-input--solid--white:hover textarea:not(:disabled) {
    background-color: #fff;
  }
  .i-input--small,
  .i-input--small input:not([type=radio]):not([type=checkbox]):not([type=file]),
  .i-input--small optgroup,
  .i-input--small select,
  .i-input--small textarea {
    margin-bottom: 0;
  }
  .i-input--small.i-input--has-description--js {
    margin-bottom: 28px;
  }
  .i-input--light input:not([type=radio]):not([type=checkbox]):not([type=file]),
  .i-input--light optgroup,
  .i-input--light select,
  .i-input--light textarea {
    border-color: #e0e0e0;
  }
  .i-input--light input:not([type=radio]):not([type=checkbox]):not([type=file]) ~ span.js--active,
  .i-input--light optgroup ~ span.js--active,
  .i-input--light select ~ span.js--active,
  .i-input--light textarea ~ span.js--active {
    color: #bdbdbd;
  }
  .i-input--hide {
    display: none;
  }
  .i-input--show {
    display: block;
  }
  .i-input.js--focus input:not([type=button]):not([type=submit]),
  .i-input.js--focus textarea {
    border-color: #f1f4f9;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active,
  input:-webkit-autofill:valid,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-transition-delay: 99999s;
    transition-delay: 99999s;
  }
  /*Common Sections*/
  /*Plugins*/
  /*Sections*/
  .i-login {
    height: 100vh;
    position: relative;
    background-color: #0855c4;
  }
  @media only screen and (min-width: 768px) {
    .i-login {
      background-color: #f1f4f9;
    }
  }
  .i-login .i-interseguro {
    background-color: #f1f4f9;
  }
  @media only screen and (min-width: 768px) {
    .i-login .i-interseguro {
      display: flex;
      align-items: center;
      height: calc(100vh - 110px);
    }
  }
  .i-login .i-interseguro__content {
    padding: 40px 0;
  }
  @media only screen and (min-width: 768px) {
    .i-login .i-interseguro__content__heading {
      margin-right: 64px;
      display: flex;
    }
  }
  .i-login .i-interseguro__content__heading h2 {
    margin: 0;
    width: 100%;
    color: #0855c4;
    text-align: center;
  }
  @media only screen and (min-width: 768px) {
    .i-login .i-interseguro__content__heading h2 {
      text-align: left;
    }
  }
  .i-login .i-interseguro__content__form {
    border-radius: 10px 0;
    box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.2);
  }
  .i-login .i-interseguro__content__form h3 {
    color: #0855c4;
    text-align: center;
    margin-bottom: 20px;
  }
  .i-login .i-interseguro__content__form button {
    text-align: center;
  }
  .i-login .i-interseguro__content__form .i-input input {
    margin-bottom: 0;
    text-align: center;
    padding: 10px 12px 0 20px;
  }
  .i-login .i-interseguro__content__form .i-input ~ .i-input--error {
    text-align: center;
  }
  .i-login .i-header__left {
    height: 50px;
  }
  .i-login .i-header__right {
    display: none;
  }
  .i-login__info {
    width: 100%;
    padding: 10px 0;
    text-align: left;
    color: #233b5e;
    background-color: #0855c4;
  }
  @media only screen and (min-width: 768px) {
    .i-login__info {
      bottom: 0;
      height: 60px;
      line-height: 40px;
      position: absolute;
    }
  }
  .i-login__info__content {
    display: flex;
    flex-direction: column;
  }
  @media only screen and (min-width: 768px) {
    .i-login__info__content {
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
    }
  }
  .i-login__info__content p {
    color: #fff;
  }
  @media only screen and (min-width: 768px) {
    .i-login__info__content p {
      margin: 0;
      font-family: "Omnes-Regular";
    }
  }
  .i-login__info__content div {
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 768px) {
    .i-login__info__content div {
      margin-bottom: 0;
    }
  }
  .i-login__info__content div a {
    color: #fff;
    display: flex;
    font-size: 14px;
    align-items: center;
    font-family: "Omnes-Semibold";
  }
  .i-login__info__content div span img {
    width: 15px;
    height: 15px;
    color: #fff;
    line-height: 40px;
    margin-right: 6px;
    text-align: center;
    display: inline-block;
    background-color: transparent;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card header {
      background-color: transparent;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
  .i-pay-card header .i-return {
    display: initial;
  }
  .i-pay-card header p {
    display: none;
  }
  @media only screen and (min-width: 640px) {
    .i-pay-card header p {
      display: inline-block;
    }
  }
  .i-pay-card > .i-container {
    padding: 0;
  }
  .i-pay-card > .i-container .i-background__left {
    background-image: unset;
    background-color: #f1f4f9;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card > .i-container {
      width: 100%;
    }
  }
  .i-pay-card .i-interseguro {
    background-color: transparent;
  }
  .i-pay-card .i-interseguro__content {
    padding: 25px 0 20px;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-interseguro__content {
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .i-pay-card .i-interseguro__content__heading {
    display: block;
    text-align: left;
    margin-bottom: 30px;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-interseguro__content__heading {
      margin-bottom: 20px;
      text-align: left;
    }
  }
  .i-pay-card .i-interseguro__content__heading span {
    color: #fff;
    margin-bottom: 10px;
    display: inline-block;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-interseguro__content__heading span {
      font-size: 20px;
    }
  }
  .i-pay-card .i-interseguro__content__heading h2 {
    margin: 0;
    width: auto;
    color: #0855c4;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-interseguro__content__heading h2 {
      line-height: 40px;
    }
  }
  .i-pay-card .i-interseguro__content__form {
    padding: 0;
    box-shadow: 0 1px 9px 1px rgba(0, 0, 0, 0.2);
  }
  .i-pay-card .i-interseguro__content__form__content {
    padding: 28px 21px 20px;
  }
  .i-pay-card .i-interseguro__content__form__content h3 {
    color: #0855c4;
    text-align: center;
  }
  .i-pay-card .i-interseguro__content__form__content > p {
    font-size: 11px;
    text-align: center;
    margin: 20px 0 15px 0;
  }
  @media only screen and (min-width: 640px) {
    .i-pay-card .i-interseguro__content__form__content > p {
      font-size: 13px;
    }
  }
  .i-pay-card .i-interseguro__content__form__content > p span {
    color: #0855c4;
  }
  .i-pay-card .i-interseguro__content__form__content > p span:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .i-pay-card .i-interseguro__content__form__content .m-question {
    position: relative;
  }
  .i-pay-card .i-interseguro__content__form__content .m-question span {
    width: 12px;
    height: 12px;
    color: white;
    font-size: 12px;
    margin-top: 2px;
    margin-left: 4px;
    position: absolute;
    border-radius: 50%;
    align-items: center;
    display: inline-flex;
    justify-content: center;
    background-color: #0855c4;
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-interseguro__content__form__content .m-question span {
      margin-top: 4px;
    }
  }
  .i-pay-card .i-interseguro__content__form__content .m-question:hover ~ .i-input__box__tooltip {
    opacity: 1;
    z-index: 10;
    visibility: visible;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box__double {
    display: flex;
    justify-content: space-between;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box__double .i-input__box {
    width: 48.5%;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box {
    position: relative;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box i {
    top: 39px;
    left: 15px;
    color: #8ea1bd;
    font-size: 20px;
    position: absolute;
  }
  @media only screen and (min-width: 360px) {
    .i-pay-card .i-interseguro__content__form__content .i-input__box i {
      top: 43px;
    }
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box input {
    color: #8ea1bd;
    padding: 0 16px;
    margin-bottom: 0;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box input[type=tel] {
    padding: 0 0 0 45px;
  }
  /*
  .i-pay-card .i-interseguro__content__form__content .i-input__box input[type=tel]:-internal-autofill-selected {
    color: #233b5e !important;
    background-color: #e2e8f1 !important;
  }
  */
  .i-pay-card .i-interseguro__content__form__content .i-input__box__tooltip {
    top: 20px;
    opacity: 0;
    z-index: 0;
    right: -20px;
    /*width: 275px;*/
    height: 103px;
    padding: 15px;
    color: white;
    transition: 0.3s;
    border-radius: 5px;
    visibility: hidden;
    position: absolute;
    background-color: #0855c4;
  }
  @media only screen and (min-width: 360px) {
    .i-pay-card .i-interseguro__content__form__content .i-input__box__tooltip {
      right: 0;
      width: 277px;
    }
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box__tooltip > span {
    top: 4px;
    position: relative;
    display: inline-block;
    vertical-align: top;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box__tooltip > span img {
    width: 40px;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box__tooltip p {
    width: 185px;
    margin-bottom: 0;
    margin-left: 12px;
    line-height: 17px;
    display: inline-block;
    vertical-align: middle;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box__tooltip p span {
    font-weight: bold;
    line-height: 17px;
    vertical-align: middle;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox {
    display: flex;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox input {
    display: none;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox input:checked ~ label {
    opacity: 1;
    background-color: white;
    border: 1px solid #e2e8f1;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox label {
    width: 24px;
    height: 24px;
    border-radius: 5px;
    border: 2px solid !important;
    border-color: #999a9b !important;
    position: relative;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox label i {
    top: unset;
    left: unset;
    color: #0855c4;
    font-size: 16px;
    font-weight: bold;
    transition: 0.4s;
  }
  .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox p {
    margin: 0;
    width: 200px;
    font-size: 10.5px;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #535D66;
  }
  @media only screen and (min-width: 360px) {
    .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox p {
      width: 200px;
      margin-bottom: 10px;
    }
  }
  @media only screen and (min-width: 640px) {
    .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox p {
      width: 200px;
      margin-bottom: 10px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-interseguro__content__form__content .i-input__box--affiliation .i-input--checkbox p {
      width: 200px;
      margin-bottom: 10px;
    }
  }
  .i-pay-card .i-interseguro__content__form__content .i-button {
    text-align: center;
    text-transform: inherit;
  }
  .i-pay-card .i-interseguro__content__form__footer {
    padding: 15px 0;
    text-align: center;
    background-color: #e2e8f1;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    color: #0855c4;
  }
  .i-pay-card .i-interseguro__content__form__footer i {
    margin: 0 7px 0 0;
  }
  .i-pay-card .i-interseguro__content__form__footer p {
    margin: 0;
  }
  .i-pay-card .i-product-cards {
    text-align: left;
    padding: 20px 0;
    color: #233b5e;
  }
  @media only screen and (min-width: 640px) {
    .i-pay-card .i-product-cards {
      padding-top: 100px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-pay-card .i-product-cards {
      padding-top: 180px;
    }
  }
  .i-pay-card .i-product-cards .i-product-card {
    border-bottom: 1px solid #e2e8f1;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .i-pay-card .i-product-cards .i-product-card:last-child {
    border-bottom: 0;
  }
  .i-pay-card .i-product-cards .i-product-card__info h3 {
    color: #233b5e;
    margin-bottom: 2px;
  }
  .i-pay-card .i-product-cards .i-product-card__info p {
    margin: 0;
  }
  .i-pay-card .i-product-cards .i-product-card .i-button-close:hover {
    background-color: #233b5e;
  }
  .i-pay-card--affiliation header {
    position: relative;
    background-color: #fff;
  }
  .i-pay-card--affiliation .i-interseguro__content {
    align-items: center;
    max-width: 350px;
    width: 100%;
    margin: 0 auto;
  }
  .i-dues {
    height: 100vh;
    background-color: #f1f4f9;
  }
  .i-dues .i-header p {
    display: none;
  }
  @media only screen and (min-width: 640px) {
    .i-dues .i-header p {
      display: inline-block;
    }
  }
  .i-dues .i-interseguro {
    padding-bottom: 20px;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-interseguro {
      padding: 40px 0;
    }
  }
  .i-dues .i-interseguro__content {
    padding: 24px 0 0;
  }
  .i-dues .i-interseguro__content__heading {
    display: block;
    margin-bottom: 0px;
  }
  @media only screen and (min-width: 460px) {
    .i-dues .i-interseguro__content__heading {
      margin: 0;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-interseguro__content__heading {
      width: 100%;
    }
  }
  .i-dues .i-interseguro__content__heading h1 {
    color: #0855c4;
    text-align: left;
    margin-bottom: 10px;
    font-weight: normal;
    font-family: "Omnes-Regular";
  }
  .i-dues .i-interseguro__content__heading h2 {
    color: #0855c4;
    margin: 0;
    line-height: 24px;
    text-align: center;
    width: 100%;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-interseguro__content__heading h2 {
      line-height: 34px;
    }
  }
  .i-dues .i-interseguro__content__heading .i-product-info {
    color: #fff;
    text-align: left;
    margin-top: 20px;
  }
  .i-dues .i-interseguro__content__heading .i-product-info p {
    margin: 0 0 10px;
  }
  .i-dues .i-interseguro__content__heading .i-product-info p:last-child {
    margin-bottom: 0;
  }
  .i-dues .i-table {
    margin-bottom: 30px;
    background: #f1f4f9;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table {
      margin-bottom: 0;
    }
  }
  .i-dues .i-table th, .i-dues .i-table td {
    padding: 5px;
    text-align: left;
    font-weight: normal;
  }
  .i-dues .i-table th {
    width: 25%;
    font-size: 11px;
  }
  .i-dues .i-table th:last-of-type {
    text-align: center;
  }
  @media only screen and (min-width: 480px) {
    .i-dues .i-table th {
      font-size: 12px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table th {
      font-size: 14px;
    }
  }
  .i-dues .i-table td {
    height: 45px;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table td {
      font-size: 16px;
    }
  }
  .i-dues .i-table td input {
    height: auto;
  }
  .i-dues .i-table tr.i-due-product {
    color: #8ea1bd;
    cursor: pointer;
    margin-bottom: 10px;
    transition: color 0.3s;
  }
  .i-dues .i-table tr.i-due-product--selected {
    color: #233b5e;
  }
  .i-dues .i-table .i-input--checkbox {
    text-align: center;
  }
  .i-dues .i-table .i-input--checkbox input:checked ~ label {
    background-color: #0855c4;
  }
  .i-dues .i-table .i-tag {
    border-radius: 20px;
    padding: 4px 8px;
    font-size: 9px;
    display: inline-block;
    width: 68px;
    text-align: center;
    text-transform: uppercase;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table .i-tag {
      width: 94px;
    }
  }
  .i-dues .i-table .i-status--defeated {
    border: 1px solid #dc3545;
    color: #dc3545;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table .i-status--defeated {
      font-size: 14px;
    }
  }
  .i-dues .i-table .i-status--available {
    border: 1px solid #11a418;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table .i-status--available {
      font-size: 14px;
    }
  }
  .i-dues .i-table .i-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .i-dues .i-table__container {
    width: 100%;
    padding: 10px;
    color: #233b5e;
    margin-bottom: 10px;
    border-radius: 10px;
    background-color: #fff;
    transition: box-shadow 0.3s;
    box-shadow: 0 2px 10px 0px rgba(0, 0, 0, 0.2);
    height: calc(100vh - 142px - 113px - 20px);
    overflow-y: auto;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table__container {
      height: calc(100vh - 50px - 138px - 30px - 115px);
    }
  }
  .i-dues .i-table__container:last-child {
    margin-bottom: 0;
  }
  .i-dues .i-table__container:hover {
    box-shadow: 0px 2px 4px 0px rgba(142, 161, 189, 0.4);
  }
  .i-dues .i-table__container table {
    width: 100%;
  }
  .i-dues .i-table__container p {
    color: #0855c4;
    font-size: 14px;
    line-height: 20px;
    margin: 20px 0 0;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table__container p {
      font-size: 16px;
    }
  }
  .i-dues .i-table__container .i-poliza {
    font-size: 12px;
    font-weight: 400;
    margin-top: 0;
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table__container .i-poliza {
      margin-bottom: 15px;
      font-size: 14px;
    }
  }
  @media only screen and (min-width: 480px) {
    .i-dues .i-table__container {
      width: 360px;
      margin: 0 auto 10px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-dues .i-table__container {
      width: 100%;
      padding: 20px;
    }
  }
  .i-dues .i-table__container__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  .i-dues .i-table__container__header h3 {
    margin: 0;
  }
  .i-dues .i-table__container__header input {
    height: auto;
  }
  .i-dues .i-table__container__content {
    text-align: left;
  }
  .i-dues .i-table__container__content p {
    margin: 0 0 3px;
  }
  .i-dues__footer {
    bottom: 0;
    width: 100%;
    z-index: 10;
    position: fixed;
    padding: 15px 0;
    text-align: center;
    background-color: #fff;
    border-top: 1px solid #deeafd;
  }
  @media only screen and (min-width: 640px) {
    .i-dues__footer {
      bottom: 0;
      width: 100%;
      position: absolute;
    }
  }
  .i-dues__footer .i-select-all {
    margin: 0 0 16px;
  }
  .i-dues__footer .i-select-all a {
    color: #0855c4;
  }
  @media only screen and (min-width: 640px) {
    .i-dues__footer .i-select-all {
      width: 100%;
      font-size: 14px;
      margin-left: auto;
      text-align: center;
    }
  }
  .i-dues__footer .i-button {
    width: 100%;
    text-align: center;
  }
  @media only screen and (min-width: 360px) {
    .i-dues__footer .i-button {
      width: 280px;
    }
  }
  .i-dues__footer .i-button i {
    top: 20px;
    right: 20px;
    text-align: right;
    position: absolute;
  }
  .i-dues__footer__price {
    display: inline;
    margin-left: 0px;
    font-weight: 300;
  }
  .i-dues__footer__price span {
    margin-left: 5px;
    font-size: 14px;
      color: #fff;
  }
  @media only screen and (min-width: 768px) {
    .i-dues__footer__price span {
      font-size: 14px;
      color: #fff;
    }
  }
  .i-affiliation > .i-container {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  @media only screen and (min-width: 1024px) {
    .i-affiliation > .i-container {
      padding-top: 60px;
      padding-bottom: 60px;
    }
  }
  @media only screen and (min-width: 640px) {
    .i-affiliation .i-receipts {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    .i-affiliation .i-receipts > * {
      width: 48%;
    }
  }
  .i-affiliation .i-receipt {
    text-align: left;
    color: #233b5e;
    padding: 30px 20px;
    margin-bottom: 20px;
    border-radius: 10px;
    background-color: transparent;
  }
  @media only screen and (min-width: 480px) {
    .i-affiliation .i-receipt {
      padding: 50px 40px;
    }
  }
  @media only screen and (min-width: 1024px) {
    .i-affiliation .i-receipt {
      padding: 40px 30px;
    }
  }
  .i-affiliation .i-receipt__card {
    padding: 13px 0;
  }
  .i-affiliation .i-receipt__card span,
  .i-affiliation .i-receipt__card strong {
    display: inline-block;
    vertical-align: middle;
  }
  .i-affiliation .i-receipt__card strong {
    display: block;
    margin: 5px 0 0 5px;
  }
  @media only screen and (min-width: 360px) {
    .i-affiliation .i-receipt__card strong {
      margin: 0 0 0 5px;
      display: inline-block;
    }
  }
  @media only screen and (min-width: 640px) {
    .i-affiliation .i-receipt__card strong {
      display: block;
      margin-top: 5px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation .i-receipt__card strong {
      margin: 0 0 0 5px;
      display: inline-block;
    }
  }
  .i-affiliation .i-receipt h3 {
    margin-bottom: 6px;
  }
  .i-affiliation .i-receipt p {
    margin: 0;
  }
  .i-affiliation .i-receipt__title {
    margin-bottom: 30px;
  }
  .i-affiliation .i-receipt .i-customer-info p {
    margin: 0 0 4px;
  }
  .i-affiliation .i-receipt .i-product-info {
    padding: 20px 0;
    margin-top: 20px;
    border-top: 2px solid #e2e8f1;
    border-bottom: 2px solid #e2e8f1;
  }
  .i-affiliation .i-receipt .i-dues-info {
    margin-top: 20px;
  }
  .i-affiliation .i-receipt .i-link {
    margin-top: 30px;
    display: inline-block;
    padding-left: 20px;
    position: relative;
  }
  .i-affiliation .i-receipt .i-link i {
    position: absolute;
    left: 0;
    top: 3px;
  }
  .i-affiliation .i-receipt .i-message-warning {
    font-size: 14px;
    margin-top: 20px;
  }
  .i-affiliation .i-message-ok {
    text-align: center;
  }
  .i-affiliation .i-message-ok i {
    font-size: 40px;
    color: #11a418;
  }
  .i-affiliation .i-message-ok h2 {
    color: #11a418;
    font-size: 14px;
    font-family: "Omnes-Regular";
    margin: 20px 0 30px;
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation .i-message-ok h2 {
      font-size: 16px;
    }
  }
  .i-affiliation--invite > .i-container {
    padding: 0;
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation--invite .i-background__container {
      margin-top: 124px;
    }
  }
  .i-affiliation--invite .i-receipt {
    padding: 21px 0;
    border-radius: 0;
    margin-bottom: 0;
    background-color: #f1f4f9;
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation--invite .i-receipt {
      background-color: transparent;
    }
  }
  .i-affiliation--invite .i-receipt-detail {
    width: 100%;
    padding: 0 21px;
    border-radius: 10px;
    background-color: transparent;
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation--invite .i-receipt-detail {
      padding: 21px 30px;
      border-radius: 10px;
    }
    .i-affiliation--invite .i-receipt-detail .i-receipt__card {
      padding: 13px 0;
    }
    .i-affiliation--invite .i-receipt-detail .i-receipt__card span,
  .i-affiliation--invite .i-receipt-detail .i-receipt__card strong {
      display: inline-block;
      vertical-align: middle;
    }
    .i-affiliation--invite .i-receipt-detail .i-receipt__card strong {
      margin: 0 0 0 5px;
    }
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation--invite header {
      background-color: transparent;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .i-affiliation--invite header .i-button-close {
      color: #fff;
    }
  }
  .i-affiliation__footer {
    padding: 30px 0;
    background-color: transparent;
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation__footer {
      padding: 30px 20px;
    }
  }
  .i-affiliation__footer i {
    font-size: 40px;
    margin-bottom: 0;
  }
  .i-affiliation__footer p:first-of-type {
    color: #0855c4;
    font-size: 16px;
    font-family: "Omnes-Regular";
  }
  .i-affiliation__footer p {
    font-size: 12px;
    color: #233b5e;
  }
  @media only screen and (min-width: 768px) {
    .i-affiliation__footer p {
      font-size: 14px;
    }
  }
  .i-affiliation__footer .i-button {
    margin-top: 10px;
    text-transform: inherit;
    text-align: center;
  }

#inputTarjeta, #inputFechaNacimiento, #inputCvv {
  border: 1px solid #999a9b;
  padding: 12px 5px 5px 15px;
  height: 45px;
  background-color: white;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  -webkit-box-flex: 1;
  /* display: table; */
  margin-bottom: 5px;
  border-radius: 5px;
}
.__PrivateStripeElement {
  vertical-align: middle;
  display: table-cell!important;
}
</style>



// WEBPACK FOOTER //
// src/components/payment/Niubiz.vue